import type { MopDeliveryState } from "../../api/types";
import { StatusBadge, statusMeta, type StatusMeta } from "../../lib/status";

export const MOP_STATES: Record<MopDeliveryState, StatusMeta> = {
  pending: statusMeta("mop_pending"),
  sent: statusMeta("mop_sent"),
  error: statusMeta("mop_error"),
  invalidated: statusMeta("mop_invalidated"),
};

export function MopStatus({ state }: { state: MopDeliveryState }) {
  return <StatusBadge status={`mop_${state}`} />;
}

export function operationLabel(value: string | null): string {
  const labels: Record<string, string> = { accensione: "Accensione", spegnimento: "Spegnimento",
    modifica_orari: "Modifica orari", cambio_stagione: "Cambio stagione", manutenzione_ordinaria: "Manutenzione ordinaria" };
  return value ? labels[value] ?? value : "—";
}

export function formatMopDate(value: string | null): string {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString("it-IT", {
    timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}
